import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GroupedInterlinksComponent} from './grouped-interlinks.component';
import {TagTextModule} from '../tag-text/tag-text.module';
import {AdsBannersModule} from "../ads-banners/ads-banners.module";
import { TextModule } from '../text/text.module';


@NgModule({
    declarations: [
        GroupedInterlinksComponent
    ],
    exports: [
        GroupedInterlinksComponent
    ],
    imports: [
        CommonModule,
        TagTextModule,
        AdsBannersModule,
        TextModule
    ]
})
export class GroupedInterlinksModule {
}
